import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { FooterService } from '../../services/footer.service';
import { AudioDescriptor } from 'src/app/shared/enums/audio-descriptor';
import { AudioType } from 'src/app/shared/enums/audio-type';
import { PageTransitionService } from 'src/app/shared/services/page-transitions/page-transitions.service';
import { ActivityService } from 'src/app/shared/services';

@Component({
  selector: 'htc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
  buttonEnabled = false;
  isActivityCompleteInProgress = false;
  toolbarSubscriptions = new Subscription();
  clickDescriptor = AudioDescriptor.SELECT_MAJOR_LO;
  clickType = AudioType.audio_SfxClick;

  constructor(
    public footerService: FooterService,
    public pageTransitionsService: PageTransitionService,
    public activityService: ActivityService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.toolbarSubscriptions.add(
      this.footerService.getFooterButtonEnabled().subscribe(isEnabled => {
        this.buttonEnabled = isEnabled;
        this.cdr.markForCheck();
      })
    );
    this.toolbarSubscriptions.add(
      this.activityService.activitySubmitInProgress$.subscribe(isInProgress => {
        this.isActivityCompleteInProgress = isInProgress;
        this.cdr.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.toolbarSubscriptions.unsubscribe();
    this.footerService.cleanup();
  }
}
